import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";


// Get Table Data
export const WTPMachineryChecklistTableDataAPI = createAsyncThunk("WTPMachineryChecklistTableData", async ({ data }) => {
    const {
        ReadingDate,
        M_WardID,
        M_WTP_EquipmentTypeID,
        M_WTP_EquipmentMasterID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_MachineryChecklist_Select?ReadingDate=${ReadingDate}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_EquipmentTypeID=${M_WTP_EquipmentTypeID ? M_WTP_EquipmentTypeID : '0'}&M_WTP_EquipmentMasterID=${M_WTP_EquipmentMasterID ? M_WTP_EquipmentMasterID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const WTPMachineryChecklistTableDataSlice = createSlice({
    name: "WTPMachineryChecklistTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPMachineryChecklistTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPMachineryChecklistTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPMachineryChecklistTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPMachineryChecklistTableDataReducer = WTPMachineryChecklistTableDataSlice.reducer

export const WTPMachineryChecklistTableExportDataAPI = createAsyncThunk("WTPMachineryChecklistTableExportData", async ({ data }) => {
    const {
        ReadingDate,
        M_WardID,
        M_WTP_EquipmentTypeID,
        M_WTP_EquipmentMasterID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_MachineryChecklist_Select?ReadingDate=${ReadingDate}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_EquipmentTypeID=${M_WTP_EquipmentTypeID ? M_WTP_EquipmentTypeID : '0'}&M_WTP_EquipmentMasterID=${M_WTP_EquipmentMasterID ? M_WTP_EquipmentMasterID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const WTPMachineryChecklistTableExportDataSlice = createSlice({
    name: "WTPMachineryChecklistTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPMachineryChecklistTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WTPMachineryChecklistTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WTPMachineryChecklistTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPMachineryChecklistTableExportDataReducer = WTPMachineryChecklistTableExportDataSlice.reducer


export const WTPMachineryChecklistPostDataAPI = createAsyncThunk("WTPMachineryChecklistPostData", async ({ data }) => {
    const {
        T_WTP_MachineryChecklistID,
        M_WTP_MachineryActionsID,
        Remarks,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_WTP_MachineryChecklistID", T_WTP_MachineryChecklistID);
    formdata.append("M_WTP_MachineryActionsID", M_WTP_MachineryActionsID);
    formdata.append("Remarks", Remarks);
    formdata.append("M_UserID", M_UserID);


    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/Post_WEB_WTP_T_WTP_MachineryChecklist_Update`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const WTPMachineryChecklistPostDataSlice = createSlice({
    name: "WTPMachineryChecklistPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPMachineryChecklistPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPMachineryChecklistPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPMachineryChecklistPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPMachineryChecklistPostDataReducer = WTPMachineryChecklistPostDataSlice.reducer

// -----------------Delete API ---------------

export const WTPMachineryChecklistDeleteAPI = createAsyncThunk("WTPMachineryChecklistDelete", async ({ data }) => {
    const {
        T_WTP_MachineryChecklistID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_WTP_MachineryChecklistID", T_WTP_MachineryChecklistID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_WTP_T_WTP_MachineryChecklist_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const WTPMachineryChecklistDeleteSlice = createSlice({
    name: "WTPMachineryChecklistDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPMachineryChecklistDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPMachineryChecklistDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(WTPMachineryChecklistDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPMachineryChecklistDeleteReducer = WTPMachineryChecklistDeleteSlice.reducer